import React from 'react';
import cn from 'classnames';
import Avatar from '../avatar';
import Company from './company';

interface Props {
  author?: ArticleAuthor;
  oneOffAuthor?: ArticleOneOffAuthor;
  className?: string;
}

const mapAuthor = (author?: ArticleAuthor) => {
  if (!author) {
    return {};
  }
  return {
    name: author.title,
    ...author.authorDetails
  };
};

export const Author = ({ author, oneOffAuthor, className }: Props) => {
  const authorToRender: any = oneOffAuthor ? oneOffAuthor : mapAuthor(author);
  const name = authorToRender.name || 'Unknown';
  return (
    <>
      <div className={cn('flex py-4', className)}>
        <div className='flex-shrink-0 w-16 h-16 rounded-full overflow-hidden mr-4 mb-4'>
          <Avatar
            name={name}
            image={
              authorToRender?.image?.sourceUrl ||
              authorToRender?.image?.mediaItemUrl
            }
          />
        </div>
        <div className='flex-grow'>
          <h4>{name}</h4>
          {authorToRender?.jobTitle && <p>{authorToRender.jobTitle}</p>}
          <Company
            company={authorToRender?.company}
            companyUrl={authorToRender?.companyWebsiteUrl}
          />
        </div>
      </div>
      {authorToRender?.bio && <p>{authorToRender.bio}</p>}
    </>
  );
};

const ArticleAuthor = ({ author, oneOffAuthor, className }: Props) => {
  return (
    <div className={cn(className, 'bg-abn-gray-light p-4 text-sm')}>
      <p>Article by:</p>
      <Author author={author} oneOffAuthor={oneOffAuthor} />
    </div>
  );
};

export default ArticleAuthor;
